import ApolloClient from 'apollo-client';
import { VuexModule } from 'vuex-module-decorators';

export default class AbstractModule extends VuexModule {
  public apollo!: ApolloClient<any>;
}
